import { json } from '@newtontechnologies/beey-api-js-client/receivers';
import { apiV2 } from '@newtontechnologies/beey-api-js-client/endpoints';
export const fetchManagementGroups = async (connection) => connection.fetch()
    .url(apiV2.admin.managementGroups.url())
    .receive(json())
    .fetch();
export const addManagementGroup = async (connection, groupName, notes, externalId) => connection.fetch()
    .url(apiV2.admin.managementGroups.url())
    .postJson({
    groupName,
    notes,
    externalId,
})
    .receive(json())
    .fetch();
export const updateManagementGroup = async (connection, Id, GroupName, Notes, ExternalId) => connection.fetch()
    .url(apiV2.admin.managementGroups.groupId(Id).url())
    .putJson({
    GroupName,
    Notes,
    ExternalId,
})
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
export const addManagementGroupCredit = async (connection, groupId, credit) => connection.fetch()
    .url(apiV2.admin.managementGroups.groupId(groupId).credit.add.url())
    .putJson({ credit })
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
export const removeManagementGroupCredit = async (connection, groupId, credit) => connection.fetch()
    .url(apiV2.admin.managementGroups.groupId(groupId).credit.subtract.url())
    .putJson({ credit })
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
export const fetchManagementGroupCredit = async (connection, groupId) => connection.fetch()
    .url(apiV2.admin.managementGroups.groupId(groupId).credit.url())
    .receive(json()
    .map((data) => data.balance))
    .fetch();
